
<div style="padding-bottom: 26px">
    <editor
        v-model="content"
        :init="options"
        api-key="g9s4yw3w3h70a5m6v4fwf6lzzrczn9ot88hzq9578bh14abx"
    ></editor>
</div>
